import { Column, ColumnGroup } from 'rc-table'
import { TextLegacy } from '@/components/common'
import Table from '@/components/common/table/table'
import { FontResponsiveSizeType } from '@/components/common/texts/TextBase'
import LinkButtonGotoPolicyPage from '@/components/domains/policy/LinkButtonGotoPolicyPage'
import { ENV_CONFIG } from '@/constants/env/config'
import { HospitalListUrl } from '@/constants/hospital-url.const'
import ROUTES from '@/constants/legacy/constRoutes'

const PolicyBeforePrivacy = ({ fontSize = { xs: 12, md: 14 } }: { fontSize?: FontResponsiveSizeType }) => {
  const columnsConsignment = [
    {
      title: '위탁 업체',
      dataIndex: 'company',
      key: 'company',
    },
    {
      title: '위탁 업무',
      dataIndex: 'job',
      key: 'job',
    },
    {
      title: '보유 및 처리기간',
      dataIndex: 'period',
      key: 'period',
      render: (value: string, _record: any, index: number) => {
        const rowSpan = index === 0 ? 7 : 0
        return { children: value, props: { rowSpan } }
      },
    },
  ]
  const dataPrivacyItem = [
    {
      key: '1',
      service: 'Kakaotalk으로 로그인',
      must: '이름, 성별, 생년월일, 휴대폰 번호',
    },
    {
      key: '2',
      service: 'Naver ID로 로그인',
      must: '이메일',
    },
    {
      key: '3',
      service: 'Apple ID로 로그인',
      must: '이메일',
    },
  ]

  const dataSourceConsignment = [
    {
      key: 1,
      company: '롯데글로벌로지스',
      job: '고객 대상 제품 배송 및 회송',
      period: '회원 탈퇴 시 혹은 위탁 계약 종료 시 지체 없이 파기',
    },
    {
      key: 2,
      company: 'NHN한국사이버결제, 토스페이먼츠㈜',
      job: '고객의 이용대금 결제 및 정산 처리',
    },
    {
      key: 3,
      company: '(주)루나소프트, 알리고, NHN Toast',
      job: 'SMS/LMS/MMS, 카카오톡 알림톡(정보성 메시지) 등 메시지 발송 업무',
    },
    {
      key: 4,
      company: 'Braze Inc.',
      job: '모바일 사용자 대상 자동수집 정보, 마케팅 활용을 위한 모바일(앱푸시, 이메일 등) 발송 관련 서비스',
    },
    {
      key: 5,
      company: '(주)유세스파트너스, Zendesk',
      job: '고객센터 운영, 고객 문의 및안내 관리 등 고객 상담',
    },
    {
      key: 6,
      company: '㈜아임포트',
      job: '주문 연동 전자결제 업무',
    },
    {
      key: 7,
      company: 'Amplitude Inc. Appsflyer ',
      job: '사용자의 상품, 서비스 이용 및 통계 분석',
    },
  ]

  const columnsPersonalInfo = [
    {
      title: '위탁 업체',
      dataIndex: 'company',
      key: 'company',
    },
    {
      title: '이전\n 국가',
      dataIndex: 'toNation',
      key: 'toNation',
    },
    {
      title: '이전 일시 및 방법',
      dataIndex: 'dateAtAndMethod',
      key: 'dateAtAndMethod',
      render: (value: string, _record: any, index: number) => {
        const rowSpan = index === 0 ? 4 : 0
        return { children: value, props: { rowSpan } }
      },
    },
    {
      title: '이전 개인정보 항목',
      dataIndex: 'info',
      key: 'info',
    },
    {
      title: '개인정보 이용 목적',
      dataIndex: 'purpose',
      key: 'purpose',
    },
    {
      title: '보유 및 처리 기간',
      dataIndex: 'period',
      key: 'period',
      render: (value: string, _record: any, index: number) => {
        if (index === 0) {
          return { children: value, props: { rowSpan: 4 } }
        }
        return { children: null, props: { rowSpan: 0 } }
      },
    },
  ]
  const dataSourcePersonalInfo = [
    {
      key: 1,
      company: 'Zendesk\n[privacy@zendesk.com]',
      toNation: '미국',
      dateAtAndMethod: '서비스 이용 시점에 네트워크를 통한 전송',
      info: '이름, 이메일, 휴대폰 번호',
      purpose: '고객 문의 및 안내 관리',
      period: '회원 탈퇴 시 혹은 위탁 계약 종료 시 지체 없이 파기',
    },
    {
      key: 2,
      company: 'Braze Inc.\n[privacy@braze.com]',
      toNation: '미국',
      info: '이메일, 이메일, 휴대폰 번호 및 서비스 이용 관련 정보',
      purpose: '모바일 사용자 대상 자동수집 정보, 모바일 알림 서비스 제공, 앱푸시 발송',
      period: '회원 탈퇴 시 혹은 위탁 계약 종료 시 지체 없이 파기',
    },
    {
      key: 3,
      company: 'Amplitude Inc.\n[privacy@amplitude.com]',
      toNation: '미국',
      info: '서비스 이용 기록',
      purpose: '사용자의 상품, 서비스 이용 및 통계 분석',
      period: '회원 탈퇴 시 혹은 위탁 계약 종료 시 지체 없이 파기',
    },
    {
      key: 4,
      company: 'Appsflyer\n[privacy@appsflyer.com]',
      toNation: '미국',
      info: '서비스 이용 기록',
      purpose: '사용자의 상품, 서비스 이용 및 통계 분석',
      period: '회원 탈퇴 시 혹은 위탁 계약 종료 시 지체 없이 파기',
    },
  ]

  const dataSourceFindHospitalServiceInfo = [
    {
      key: 1,
      service: '병원찾기',
      serviceContent:
        '① 위치정보를 활용한 병원 찾기 서비스: 정보 검색을 요청하거나 개인위치정보주체 또는 이동성 있는 기기의 위치정보를 이용한 검색결과 및 주변결과(주변 동물병원 등)을 제시합니다',
    },
    {
      key: 2,
      serviceContent:
        '② 병원 안내 등 생활편의 서비스 제공: 이용자가 설정한 위치에서부터 선택한 동물병원까지의 교통정보와 길 안내 등 최적의 경로를 제공합니다.',
    },
  ]
  const columnsFindHospitalServices = [
    {
      title: '서비스명',
      dataIndex: 'service',
      key: 'service',
      render: (value: string, _record: any, index: number) => {
        const rowSpan = index === 0 ? 2 : 0
        return { children: value, props: { rowSpan: rowSpan } }
      },
    },
    {
      title: '서비스 내용',
      dataIndex: 'serviceContent',
      key: 'serviceContent',
    },
  ]

  return (
    <div style={{ padding: 10, paddingTop: 40 }}>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {}
      </TextLegacy>

      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {"주식회사 핏펫(이하 '회사')은 관련 법령에 따라 회사가 운영하는 인터넷 관련 서비스('자사 모바일 기기용 애플리케이션'과 '핏펫몰_fitpetmall.com')(이하 '서비스')를 이용하는 이용자의 개인정보를 보호하고, 이와 관련한 고충을 신속하고 원활하게 처리하기 위하여 다음과 같이 개인(위치)정보 처리방침을 수립•공개합니다\n" +
          '\n' +
          '제1조(개인정보의 처리 목적)\n' +
          '회사는 다음의 목적을 위하여 개인정보를 처리합니다.\n'}
      </TextLegacy>
      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          {'1. 회원 가입 및 관리: 회원가입의사 확인, 본인 식별인증, 연령인증, 회원자격 유지 및 관리, 서비스 부정이용 방지, 각종 고지·통지\n' +
            '2. 재화 또는 서비스 및 부대서비스 제공: 물품 배송, 기본/맞춤형 서비스 제공, 계약서·청구서 발송, 본인인증, 연령인증, 요금결제 및 정산, 채권추심, 고객상담서비스\n' +
            '3. 고충처리: 이용자의 신원 확인, 고충사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보\n' +
            '4. 마케팅 및 광고에의 활용: 맞춤형 광고 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공\n' +
            '5. 서비스 개선 및 개발: 기존 서비스 개선 및 신규 서비스, 맞춤형 서비스 개발\n' +
            '6. 가명정보의 활용: 통계작성, 과학적 연구, 공익적 기록보존 등을 위한 가명처리 및 가명정보의 활용\n'}
        </TextLegacy>
      </div>
      <div style={{ height: 20 }} />
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`제2조(처리하는 개인정보 항목)
① 회사는 서비스 이용자에 대하여 다음의 개인정보항목을 수집하여 처리하고 있습니다. `}
      </TextLegacy>
      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          {`1. 회원 가입 시 기본수집사항(필수항목): 이메일, 이름, 휴대폰 번호, 주소, 생년월일, SNS 계정 이메일(간편가입시)
            2. 재화 또는 서비스 구매시 수집사항(필수항목): 구매자 정보(이름, 휴대폰 번호, 이메일), 수취인 정보(이름, 휴대폰번호, 이메일)
            3. 회원 로그인 선택 수단에 따라 제휴사로부터 추가로 제공받는 사항`}
        </TextLegacy>
      </div>
      <Table data={dataPrivacyItem} style={{ paddingBottom: 10 }}>
        <Column title={`로그인 시 이용자가 선택한 제휴사/서비스`} dataIndex="service" key="1" />
        <ColumnGroup title="제휴사 제공 항목">
          <Column title="필수" dataIndex="must" key="2" />
          <Column title="선택" dataIndex="option" key="3" />
        </ColumnGroup>
      </Table>
      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          {`4. 유료서비스 이용 시 수집사항 
- 신용카드 결제 시: 카드사명, 카드번호 등 신용카드정보
- 계좌이체 시: 예금주명, 계좌번호, 계좌보유은행 등 은행계좌정보
- 휴대전화번호 결제 시: 휴대전화번호, 통신사 등 결제정보
5. 서비스 이용과정에서 아래 개인정보 항목이 자동으로 수집: IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문 기록, 기기 정보, 불량 이용 기록
6. 고충처리 시: 이용자로부터 위 각 정보 중 필요한 항목 및 해당 고충처리에 필요한 별개 항목을 수집 및 처리
7. 동물등록대행 서비스 이용 시 수집사항: 이름, 휴대폰번호, 주민등록상 주소, 현 거주지 주소, 고유식별정보인 주민등록번호 또는 외국인등록번호
`}
        </TextLegacy>
      </div>
      <div style={{ height: 20 }} />
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
제3조(개인정보의 처리 및 보유기간) 
① 회사는 이용자로부터 개인정보를 수집할 때 동의 받은 개인정보 보유, 이용기간 또는 법령에 따른 개인정보 보유, 이용기간 내에서 개인정보를 처리, 보유합니다. 
② 전항에도 불구하고 회사는 다음의 사유에 해당하는 경우에는 해당 기간 종료 시까지 보존합니다. `}
      </TextLegacy>
      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          {`
1. 서비스 이용 관련 개인정보 (로그기록): 「통신비밀보호법」상 보존기간인 3개월
2. 계약 또는 청약철회 등에 관한 기록 및 대금결제 및 재화 등의 공급에 관한 기록: 「전자상거래 등에서의 소비자보호에 관한 법률」상 보존기간인 5년
3. 소비자의 불만 또는 분쟁처리에 관한 기록: 「전자상거래 등에서의 소비자보호에 관한 법률」상 보존기간인 3년
4. 표시 광고에 관한 기록:  「전자상거래 등에서의 소비자보호에 관한 법률」상 보존기간인 6개월
5. 세법이 규정하는 모든 거래에 관한 장부 및 증빙서류: 「국세기본법」상 보존기간인 5년
6. 서비스이용에 따른 채권•·채무관계 잔존 시에는 해당 채권·채무관계 정산 시까지
7. 개인 식별 정보: 회원 탈퇴시 또는 본인의 수집, 이용동의 철회요청시로부터 90 일까지
          `}
        </TextLegacy>
      </div>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`③ 회사는 1년 또는 이용자가 별도로 정한 기간 동안 서비스를 이용하지 않은 이용자의 개인정보를 별도로 개인정보를 분리보관 또는 삭제하여 관리합니다.
④ 회사는 개인정보 보유기간 경과 후 5일 이내에 당해 개인정보를 파기합니다`}
      </TextLegacy>
      <div style={{ height: 20 }} />
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
제4조(개인정보의 제3자 제공) 
① 회사는 이용자의 동의를 받거나 개인정보 보호법 또는 다른 법률의 특별한 규정이 있는 경우에만 개인정보를 제3자에게 제공합니다. 
② 이용자가 회사의 ‘상담하기 서비스’와 ‘동물병원 연계 서비스’, ‘반려동물 검사 서비스’, ‘병원예약 서비스’, ‘병원 찾기 서비스’, ‘셀러 서비스’, ‘동물등록대행 서비스’를 이용하는 경우 회사는 정보주체의 동의를 얻어 제3자에게 다음 각호와 같이 정보를 제공할 수 있습니다.
`}
      </TextLegacy>
      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize} style={{ display: 'inline' }}>
          {`
1. 제휴 수의사
1) 개인정보를 제공 받는 자 : 핏펫 제휴 수의사
2) 개인정보 이용 목적 : 상담 서비스 제공, 병원 연계 진행, 반려동물 정보 확인, 통계 작성
3) 개인정보 항목
① 회원 정보 : 성명, 닉네임, 생년월일, 성별, 이메일, 휴대전화번호, 주소, 상담 정보
② 반려동물 정보 : 종류, 성별, 이름, 나이, 몸무게, 품종, 활동성, 중성화 여부, 소변검사결과, 산책 기록
4) 개인정보를 제공받는 자의 개인정보 보유 및 이용기간: 개인정보 제공일로부터 1년(법령의 규정에 의하여 개인정보를 보유하여야 하는 경우에는 해당 법령에 따릅니다.)

2. 제휴 동물병원
          `}
        </TextLegacy>
        <TextLegacy size={fontSize}>
          1) 개인정보를 제공 받는 자 : 핏펫 제휴 동물병원[
          <LinkButtonGotoPolicyPage text="링크 참조" url={HospitalListUrl} />]
        </TextLegacy>
      </div>

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          {`2) 개인정보 이용 목적 : 병원예약 서비스 진행 
3) 개인정보 항목
- 회원 정보 : 이름, 휴대전화번호, 주소, 생년월일 
- 반려동물 정보 : 종류, 성별, 이름, 나이, 몸무게, 품종, 활동성, 중성화 여부, 소변검사결과, 산책 기록
4) 개인정보를 제공받는 자의 개인정보 보유 및 이용기간: 개인정보 제공일로부터 1년(법령의 규정에 의하여 개인정보를 보유하여야 하는 경우에는 해당 법령에 따릅니다.)

3. 제휴 보험사 (보상신청시)
1) 개인정보를 제공 받는 자 : DB손해보험㈜
2) 개인정보 이용 목적 : 펫케어플러스, 어헤드케어(어헤드베이직케어 등)에 따른 보상신청
3) 개인정보 항목
4) 개인정보를 제공받는 자의 개인정보 보유 및 이용기간: 개인정보 제공일로부터 1년(법령의 규정에 의하여 개인정보를 보유하여야 하는 경우에는 해당 법령에 따릅니다.)

4. 모발 검사 제휴 연구원
1) 개인정보를 제공 받는 자 : ㈜와이에스환경기술연구원
2) 개인정보 이용 목적 : 모발검사 결과 제공, 통계, 연구, 결과에 대한 상담
3) 개인정보 항목
- 회원 정보 : 성명, 휴대전화번호, 주소
- 반려동물 정보 : 반려동물의 기본 정보를 포함한 설문 내용
4) 개인정보를 제공받는 자의 개인정보 보유 및 이용기간: 개인정보 제공일로부터 1년(법령의 규정에 의하여 개인정보를 보유하여야 하는 경우에는 해당 법령에 따릅니다.)

5. 유전병 검사 제휴 연구원
1) 개인정보를 제공 받는 자 : 유전자 검사기관(테라젠바이오)
2) 개인정보 이용 목적 : 반려동물 및 검사 신청 정보 확인 목적
3) 개인정보 항목
- 회원 정보 : 성명, 주소, 연락처, 이메일
4) 개인정보를 제공받는 자의 개인정보 보유 및 이용기간: 개인정보 제공일로부터 1년(법령의 규정에 의하여 개인정보를 보유하여야 하는 경우에는 해당 법령에 따릅니다.)

6. 판매자(셀러)
          `}
        </TextLegacy>
        <TextLegacy size={fontSize}>
          1) 개인정보를 제공 받는 자 : 판매자(셀러)[
          <LinkButtonGotoPolicyPage text="링크 참조" url={`${ENV_CONFIG.fitpetmallHost}${ROUTES.POLICY.SELLERS}`} />]
        </TextLegacy>
      </div>

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          {`2) 개인정보 이용 목적 : 상품(서비스) 배송(전송), 반품, 환불, 고객상담 등 구매계약의 이행을 위해 필요한 업무의 처리
3) 개인정보 항목
- 회원 정보 : 이름, 휴대전화번호, 주소 (구매자와 수취인이 다를 경우는 수취인의 정보가 함께  제공됩니다)
4) 개인정보를 제공받는 자의 개인정보 보유 및 이용기간: 개인정보 제공일로부터 3개월(법령의 규정에 의하여 개인정보를 보유하여야 하는 경우에는 해당 법령에 따릅니다.)

7. 제휴 동물등록 대행업체 및 지방자치단체
1) 개인정보를 제공 받는 자: ㈜ 폴리매스  
2) 개인정보 이용 목적 : 동물등록대행 서비스 제공 및 유기동물, 유실동물의 반환
3) 개인정보 항목
- 회원정보: 이름, 휴대전화번호, 주민등록상 주소, 현 거주지 주소, 주민등록번호 또는 외국인등록번호 - 반려동물 정보: 이름, 생년월일, 입양일, 품종, 털색, 몸무게, 성별, 중성화여부 4)개인정보를 제공받는 자의 개인정보 보유 및 이용기간: 제공 목적 달성시까지(법령의 규정에 의하여 개인정보를 보유하여야 하는 경우에는 해당 법령에 따릅니다)
          `}
        </TextLegacy>
      </div>
      <div style={{ height: 20 }} />
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
제5조(개인정보처리의 위탁) 
① 회사는 원활한 개인정보 업무처리를 위하여 국내에서 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
        `}
      </TextLegacy>
      <Table data={dataSourceConsignment} columns={columnsConsignment} style={{ paddingBottom: 10 }}>
        {columnsConsignment.map((column) => (
          <Column title={column.title} dataIndex={column.dataIndex} key={column.key} />
        ))}
      </Table>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {'② 회사는 아래와 같이 국외의 제3자에게 개인정보 처리업무를 위탁하고 있습니다.'}
      </TextLegacy>
      <Table
        data={dataSourcePersonalInfo}
        columns={columnsPersonalInfo}
        style={{ paddingBottom: 10 }}
        scroll={{ x: 1600 }}
      >
        {columnsPersonalInfo.map((column) => (
          <Column title={column.title} dataIndex={column.dataIndex} key={column.key} />
        ))}
      </Table>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
        제6조(수집목적과 합리적으로 관련된 범위 내의 개인정보 이용 및 제공) 
회사는 당초 수집 목적과 합리적인 범위 내에서 아래 각 기준을 고려하여, 이용자의 동의 없이 개인정보를 이용 또는 제3자에게 제공할 수 있습니다. 
`}
      </TextLegacy>
      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          {`1. 당초 수집 목적과 관련성이 있는지 여부: 당초 수집 목적과 추가적 이용·제공 목적이 성질이나 경향에 있어 연관이 있는지 등을 고려하여 따라 판단
2. 개인정보를 수집한 정황 또는 처리 관행에 비추어 볼 때 개인정보의 추가적인 이용 또는 제공에 대한 예측 가능성이 있는지 여부: 개인정보처리자와 이용자 간의 관계, 기술 수준 및 발전 속도, 상당한 기간동안 정립된 일반적인 사정(관행) 등을 고려하여 판단
3. 이용자의 이익을 부당하게 침해하는지 여부: 추가적인 이용 목적과의 관계에서 이용자의 이익이 실질적으로 침해되는지 및 해당 이익 침해가 부당한지 등을 고려하여 판단
4. 가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부: 침해 가능성을 고려한 안전 조치가 취해지는지 등을 고려하여 판단          

          `}
        </TextLegacy>
      </div>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
제7조(이용자와 법정대리인의 권리·의무 및 행사방법) 
① 이용자는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.
② 제1항에 따른 권리 행사는 서면, 전자우편 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체 없이 조치하겠습니다.
③ 제1항에 따른 권리 행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여서 하실 수 있습니다. 이 경우 수임인에 대한 위임사실을 확인할 수 있는 위임장을 제출하셔야 합니다.
④ 개인정보 보호법 등 관계 법령에서 정하는 바에 따라 이용자의 개인정보 열람·정정·삭제·처리정지 요구 등의 권리 행사가 제한될 수 있습니다.
⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
⑥ 회사는 이용자 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.

제8조(개인정보의 파기) 
① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 해당 일로부터 5일 이내에 해당 개인정보를 파기합니다. 
② 이용자로부터 동의 받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 제3조 제2항에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다. 
③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.  
`}
      </TextLegacy>
      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          {`1. 파기절차: 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다. 
2. 파기방법: 회사는 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 기술적 방법을 이용하여 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.           
          `}
        </TextLegacy>
      </div>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
제9조(개인정보의 안전성 확보조치) 
회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.        
        `}
      </TextLegacy>
      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          {`1. 관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등
2. 기술적 조치: 해킹 등에 대비한 기술적 대책개인정보의 암호화, 접속기록의 보관 및 위변조 방지 등
3. 물리적 조치: 서버실, 자료보관실 등의 접근통제 등
          `}
        </TextLegacy>
      </div>

      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
제10조(개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항) 
회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 아래와 같이 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.    
        `}
      </TextLegacy>
      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          {`1. 쿠키의 사용목적: 이용자의 접속 빈도나 방문 시간 등을 분석, 이용자의 서비스 사용 패턴 파악 및 자취 추적, 보안 접속 여부, 이용자 규모 등을 통해 보안 관리 및 서비스 개선 및 신규 서비스 개발, 맞춤형 서비스 및 광고 제공에 이용합니다. 
2. 쿠키의 설치∙운영 및 거부: 서비스 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹 브라우저에서 옵션의 설정을 변경함으로써 쿠키의 저장을 거부할 수 있습니다.
3. 쿠키 저장을 거부할 경우 일부 서비스 이용에 어려움이 발생할 수 있습니다.
          `}
        </TextLegacy>
      </div>

      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
제11조(개인정보 보호책임자) 
① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다. 
- 성명 : 성주엽
- 직책 : 커머스개발실장
- 연락처 : 02-6339-1800, contact@fitpet.co.kr
② 이용자는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 아래 담당부서로 문의하실 수 있습니다. 
- 부서명:커머스개발팀
- 연락처: 02-6339-1800, contact@fitpet.co.kr    
        `}
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
제12조 (위치정보의 처리목적) 
회사는 다음의 목적을 위하여 위치정보를 처리합니다.
-병원찾기 서비스의 제공    
      `}
      </TextLegacy>
      <Table data={dataSourceFindHospitalServiceInfo} style={{ paddingBottom: 10 }}>
        {columnsFindHospitalServices.map((column) => (
          <Column title={column.title} dataIndex={column.dataIndex} key={column.key} />
        ))}
      </Table>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
제13조 (위치정보의 보유기간) 
회사는 병원찾기 서비스 제공 및 민원처리를 위해 위치정보 수집·이용·제공사실 확인자료를 자동 기록·보존하며, 해당 자료는 6개월간 보관합니다.
      `}
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
제14조(위치정보의 파기)  
① 회사는 위치정보 보유기간의 경과, 처리목적 달성 등 위치정보가 불필요하게 되었을 때에는 해당 일로부터 5일 이내에 해당 위치정보를 파기합니다.
② 이용자로부터 동의 받은 위치정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 관련 법령에 따라 위치정보를 계속 보존하여야 하는 경우에는, 해당 위치정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다. 
③ 위치정보 파기의 절차 및 방법은 다음과 같습니다.  
      `}
      </TextLegacy>
      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          {`1. 파기절차: 회사는 파기 사유가 발생한 위치정보를 선정하고, 회사의 위치정보 보호책임자의 승인을 받아 위치정보를 파기합니다.
2. 파기방법: 회사는 전자적 파일 형태로 기록·저장된 위치정보는 기록을 재생할 수 없도록 기술적 방법을 이용하여 파기하며, 종이 문서에 기록·저장된 위치정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
          `}
        </TextLegacy>
      </div>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {`
제15조(개인(위치)정보 처리방침의 변경)  
회사는 법률이나 서비스의 변경사항을 반영하기 위한 목적 등으로 개인(위치)정보 처리방침을 수정할 수 있습니다. 개인(위치)정보 처리방침이 변경되는 경우 회사는 변경 사항 최소한 효력발생일 7일 이전에 게시하며, 변경된 개인(위치)정보 처리방침은 기재된 효력발생일에 그 효력이 발생합니다. 다만, 수집하는 개인정보의 항목, 이용목적의 변경 등과 같이 이용자 권리의 중대한 변경이 발생할 때에는 최소 30일 전에 미리 알려드리겠습니다.

부칙(2022. 7. 19.)
이 개인(위치)정보 처리방침은 2022. 7. 19부터 적용됩니다(게시일 2022. 7. 14.).

      `}
      </TextLegacy>
    </div>
  )
}

export default PolicyBeforePrivacy
